import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '../constants/Colors';
import { MaterialIcons } from '@expo/vector-icons';

export default function Tab ({...props}){
  return (
    <View style={styles.tag}>
      <Text style={styles.text}>{props.text}</Text>
      {props.remove && 
        <TouchableOpacity style={styles.removeTouchable} onPress={() => props.remove(props.removeId)} activeOpacity='0.6'>
          <MaterialIcons style={styles.remove} name="cancel" size={24} color={Colors.lightBlue2} />
        </TouchableOpacity>
      }
    </View>
  )
}

const styles = StyleSheet.create({
  tag: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: Colors.blue,
    marginRight: 6,
    marginBottom: 6,
    borderRadius: 15,
    borderColor: Colors.lightBlue2,
    borderStyle: 'solid',
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  removeTouchable: {
    marginLeft:10,
    marginRight: -3
  },
  text: {
    color: Colors.lightBlue2,
    fontSize: 20,
  }
});
